import { useTranslation } from "react-i18next";
import { LegalScreen, Paragraph, Section } from "./legal-ui";

interface Props {
  isDesktop: boolean;
  onBack: () => void;
}

const SUPPORT_EMAIL = "gjelirefail@gmail.com";

export function TermsOfServiceScreen({ isDesktop, onBack }: Props) {
  const { t } = useTranslation();
  return (
    <LegalScreen
      isDesktop={isDesktop}
      title={t("legal.terms.title")}
      lastUpdated={t("legal.lastUpdatedValue")}
      onBack={onBack}
    >
      <Paragraph>{t("legal.terms.intro")}</Paragraph>

      <Section title={t("legal.terms.account")}>
        <Paragraph>{t("legal.terms.accountBody")}</Paragraph>
      </Section>

      <Section title={t("legal.terms.use")}>
        <Paragraph>{t("legal.terms.useBody")}</Paragraph>
      </Section>

      <Section title={t("legal.terms.content")}>
        <Paragraph>{t("legal.terms.contentBody")}</Paragraph>
      </Section>

      <Section title={t("legal.terms.availability")}>
        <Paragraph>{t("legal.terms.availabilityBody")}</Paragraph>
      </Section>

      <Section title={t("legal.terms.liability")}>
        <Paragraph>{t("legal.terms.liabilityBody")}</Paragraph>
      </Section>

      <Section title={t("legal.terms.deletion")}>
        <Paragraph>{t("legal.terms.deletionBody")}</Paragraph>
      </Section>

      <Section title={t("legal.terms.changes")}>
        <Paragraph>{t("legal.terms.changesBody")}</Paragraph>
      </Section>

      <Section title={t("legal.terms.contact")}>
        <Paragraph>
          {t("legal.terms.contactBodyPrefix")}
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            style={{ color: "var(--ink)", textDecoration: "underline" }}
          >
            {SUPPORT_EMAIL}
          </a>
          .
        </Paragraph>
      </Section>
    </LegalScreen>
  );
}
